import Enlang from "./entries/en-US";

const AppLocale = {
  en: Enlang,
};

export default AppLocale;
